// extracted by mini-css-extract-plugin
export var root = "GenericHeading-root-GRmhF";
export var rootBreadcrumbs = "GenericHeading-root_breadcrumbs-GlmVf";
export var rootCategory = "GenericHeading-root-category-+3lK3";
export var rootDescription = "GenericHeading-root_description-VGQ0q";
export var rootHeading = "GenericHeading-root_heading-Dsnlh";